import styled from "styled-components";

type ContainerType = {
    background: string;
    color: string;
};

export const ContentNew = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const ContentFilter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  margin-top: 1px;
`;

export const ContainerExplication = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
`;

export const ContentFooter = styled.div<ContainerType>`

  border-radius: 10px;
`;

export const ContentExplication = styled.div<ContainerType>`
    background: ${props => props.background};
    display: flex;
    flex-direction: row;
    border-radius: 8px;
    padding: 12px;
    margin:8px 8px 0 0;
    color: ${props => props.color};
    align-items: center;
`;

export const PaddingFilters = styled.div`
  padding: 0 0 0 32px;
`;
